export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAH0lEQVR42mNgYGD4TyFm+L97926y8KgBowZQ1wBKMABoRPIcKNWC1wAAAABJRU5ErkJggg=="